import * as React                                        from 'react';
import FonctExpense                                      from '../expense/expense-component'
import PropTypes                                         from 'prop-types';
import ReactTable                                        from 'react-table';
import HotTable                                          from "react-handsontable";
import Handsontable                                      from "handsontable";
import { FormattedMessage, FormattedNumber, injectIntl } from 'react-intl';
import { Pane, Tabs }                                    from '../../../tabs'; 

const PROP_NAMES = { LABEL: "label" }

class FonctReceiptsComponent extends React.Component {
    constructor(props) {
		super(props);
	}
	render() {

        const years    = this.props.years
		const lastYear = _.last(years)
		const settings = {
			cells     : function(row, col, prop) {
				// getting source data of the row
				const rowData   = this.instance.getSourceDataAtRow(row)
				// creating cell properties
				const cellProps = {
					renderer: function(instance, TD, row, col, prop2, value, cellProperties) {
						if ("label" !== prop) { // if prop is not label (ex.: 2013, 2012, etc.)
							// applying the numeric renderer
							Handsontable.renderers.NumericRenderer.apply(this, arguments)
						} else {
							// applying the text renderer
							Handsontable.renderers.TextRenderer.apply(this, arguments)
						}

						// setting styles depending of rowData
						if (rowData && rowData.isTitle) {
							TD.style.fontWeight = "bold"
						}
					}
				}

				if (rowData && !rowData.isCurrency) cellProps.format = "0,0"

				return cellProps
			},
			colHeaders: _.concat([""], years),
			columns   : [
				{ data: PROP_NAMES.LABEL },
				...this._getYearColumns(years)
			],
			data      : this.props.data,
			readOnly  : true,
			stretchH  : "all"
        }

		return (
            <div>
                {/* <HotTable settings={settings}/> */}
                <ReactTable
                className={this.props.singled ? 'singled' : ''}
                columns={this._getColumns(this.props.years)}
                collapseOnDataChange={false}
                data={this.props.data}
                defaultSorted={[{id: 'chapter.number'}, {id: 'account.number'}]}
                loading={this.props.loading}
                minRows={5}
                showPagination = {false}/>

            </div>
		);
    }
    
    _getColumns = (
		/** @type {Number[]} */ years) => {

		return [
			{
				Header : 'Recettes de fonctionnement',
                columns: [
                    {
                        Header   : 'Libellé',
                        accessor : 'chapter',
                        minWidth : 230,
                        Cell     : cellinfo => {
                            if(cellinfo.original.chapter === null){
                                return "Non chapitrés"
                            }
                            else
                            {	
								if(cellinfo.original.info) return cellinfo.original.info.label
                                if(!cellinfo.original.label && cellinfo.original.chapter) return cellinfo.original.chapter.label
                                if(cellinfo.original.id === "receipts" || cellinfo.original.id === "orderoperation") return <strong> { cellinfo.original.label } </strong>
                                return cellinfo.original.label 
                            }
                        },
                        sortMethod : (a, b) => {
                            if(a === null) return -1
                        },
                        Footer: (
                            <span>
                              <strong>Recette total de fonctionnement :</strong>{" "}
                            </span>
                          )
                    }
                ]
			},
			{
				Header : 'Année',
                columns: this._getYearsColumns(years),
			}
		];
    }
    
    _getYearsColumns = (
		/** @type {Number[]} */ years
	) => {
		return years.map(y => ({
			Header    : y,
            accessor  : y.toString(),
            className : "text-right",
            Cell: c => 
            {
                const value = this._getCurrencyNumber(c.value ? c.value : 0)
                if(undefined !== c.original.chapter) return value
                if(c.original.id === "receipts" || c.original.id === "orderoperation") return <strong> {value} </strong>
                return value
            },
			Footer: (
                      <span>
						{
                            this._getCurrencyNumber(_.sumBy(this.props.data, row => {
                                if(row.id && "orderoperation" === row.id || row.id && "receipts" === row.id) return row[y.toString()]
                            }))
						}
					  </span>
			  )
			
		}));
    }

    _getCurrencyNumber = (value) => <FormattedNumber currency="EUR" style="currency" value={value} />

    _getYearColumns = (years) => {
		const columns   = []
		const firstYear = years[0]

		for (let i = firstYear; i < firstYear + years.length; i++) {
			columns.push({ data: i.toString(), format: "0,0.00 $", language: "fr-FR", type: "numeric" })
		}

		return columns
	}
}

export default injectIntl(FonctReceiptsComponent)

FonctReceiptsComponent.propTypes = {
	loading  : PropTypes.bool.isRequired
}


// WEBPACK FOOTER //
// ./src/component/summary/operation/receipts/receipts-component.js